import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import RootState from "../../../redux/type";
import {
  resendOtpAdmin,
  verifyOtpforgotPasswordAdmin,
} from "../../../redux/userAuth";
import { ALL_ROUTES } from "../../../routes/AllRoutes";
import { toast } from "../../../components/razor-reuse/toast/RazorToast";
import RazorModal from "../../../components/razor-reuse/modal/RazorModal";
import RazorInputField from "../../../components/razor-reuse/inputField/RazorInputField";

interface myComponentProps {
  visible?: boolean;
  onClose?: () => void;
  detail?: any;
}

const VerifyOtpModal = ({ visible, onClose, detail }: myComponentProps) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const pinRef = useRef();
  const [completeToken, setCompleteToken] = useState<boolean>(false);
  const [details, setDetails] = useState({
    otp: "",
  });

  const resendOtpFunc = async () => {
    const obj = { email: detail?.email, otpType: "password_reset" };
    const data = await dispatch(resendOtpAdmin(obj) as any);
    if (data?.payload?.data?.status) {
      toast.success(data?.payload?.data?.message);
    }
    if (data?.payload?.response?.data?.status === "failed") {
      // const messg = data?.payload?.response?.data?.errors?.email;
      // toast.error(messg);
    }
  };

  const verifyOtpFunc = async () => {
    const obj = {
      email: detail?.email,
      otpType: "password_reset",
      code: Number(details?.otp),
    };
    const data = await dispatch(verifyOtpforgotPasswordAdmin(obj) as any);
    
    if (data?.payload?.data?.status) {
      const ref = data?.payload?.data?.data?.reference;
      toast.success(data?.payload?.data?.message);
      localStorage?.setItem("password_reference", ref);
      localStorage?.setItem("user_email", detail?.email);
      navigate(ALL_ROUTES?.RESET_PASSWORD);
    }
  };

  // useEffect(() => {
  //   if(visible){
  //     setOtpKey(!otpKey)
  //   }
  // }, [visible])

  const handleClose = () => {
    setDetails((prev) => {
      return { ...prev, otp: "" };
    });

    //@ts-ignore
    pinRef?.current?.forEach((input: any) => (input.value = ""));
    onClose?.();
    setCompleteToken(false);
  };

  return (
    <>
      <RazorModal visible={visible} onClose={handleClose} onBtnClick={() => {}}>
        <div className="auth-confirm-signup-screen-modal-wrap">
          {/* title start */}
          <p className="title">
            Input 6 digit code sent to your <br /> provided email
          </p>
          {/* title end */}
          <div className="input-form-wrap">
            <RazorInputField
              pinRef={pinRef as any}
              color="black-light"
              type="pin"
              pinFieldNumber={6}
              value={details?.otp}
              onChange={(param: any) => {
                setDetails((prev) => {
                  return { ...prev, otp: param };
                });
                setCompleteToken(false);
              }}
              onComplete={() => {
                setCompleteToken(true);
              }}
              // key={otpKey as any}
            />
          </div>
          <RazorInputField
            color={`black-light`}
            value="Recover"
            type="submit"
            onSubmit={verifyOtpFunc}
            className="btn"
            disabled={loading ? false : !completeToken}
            loading={loading}
          />
          {/* dont have account start */}
          <div style={{ marginTop: "3rem" }} className="down-text-box">
            <p className="text">
              Didn’t get the link?{" "}
              {!loading && (
                <span
                  onClick={() => {
                    if (!loading) {
                      resendOtpFunc();
                    }
                  }}
                >
                  Resend Link
                </span>
              )}
            </p>
          </div>
          {/* dont have account end */}
        </div>
      </RazorModal>
    </>
  );
};

export default VerifyOtpModal;
